import { useAppStore, useSessionStore } from '@/stores'
import {messenger} from '@communication'

export default class ConnectionsProcedure {
  constructor () {
    this.name = 'conectionsProcedure'
    this.store = useAppStore()
    this.session = useSessionStore()
  }

  install = () => {
    messenger.subscribe(this.name, 'strategy:connections', this.handler)
  }
  
  uninstall = () => {
    messenger.unsubscribe(this.name)
  }

  handler = (data) => {
   this.session.updateConnections(data)
  }

}
